import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PRODUCT } from '../data/constants';
export function Guarantee() {
  return <section className="bg-ice py-5 sm:py-7" data-id="element-66" data-mp="1o33u6h0ytshr">
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-3 px-4 text-center sm:flex-row sm:gap-5 sm:px-6 sm:text-left" data-id="element-67" data-mp="22369bvhw27tb">
        <div className="flex h-20 w-20 shrink-0 flex-col items-center justify-center rounded-full border-4 border-gold bg-navy text-white sm:h-24 sm:w-24" data-id="element-68" data-mp="1x5d5h9425pw7">
          <ShieldCheckIcon className="h-7 w-7 text-gold sm:h-8 sm:w-8" strokeWidth={2} aria-hidden="true" data-id="element-69" data-mp="14fo3otjixltj" />
          <span className="mt-0.5 font-display text-xs font-extrabold uppercase leading-none" data-id="element-70" data-mp="1j4ah2pplc3i4">
            7 days
          </span>
        </div>
        <div data-id="element-71" data-mp="1ed28fvw34m60">
          <h2 className="text-xl leading-none text-navy sm:text-3xl" data-id="element-72" data-mp="1ecj096w8lc56">
            YOUR PURCHASE IS <span className="text-aviation" data-id="element-73" data-mp="qmooytrkfvn1">100% PROTECTED</span>
          </h2>
          <p className="mt-1.5 text-sm leading-snug text-graphite sm:text-base" data-id="element-74" data-mp="lo51goxbqbsk">
            Explore {PRODUCT} for 7 days. Access the complete 6-module aviation visual learning
            system and all 5 strategic study bonuses. If it isn't right for you, contact us
            within 7 days for a full refund according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}